function getQueryVariable(variable) {
    let interrogationPos = window.location.href.indexOf("?");
    if (interrogationPos < 0)
    {
        return;
    }

    //
    let query = window.location.href.substring(interrogationPos + 1);

    //
    let vars = query.split('&');
    for (let i = 0; i < vars.length; i++) {
        let pair = vars[i].split('=');
        if (pair[0] == variable) {
            return pair[1];
        }
    }
}

function getAxiosQueryVariable(requestUrl, variable) {
    let interrogationPos = requestUrl.indexOf("?");
    if (interrogationPos < 0) {
        return;
    }

    //
    let query = requestUrl.substring(interrogationPos + 1);

    //
    let vars = query.split('&');
    for (let i = 0; i < vars.length; i++) {
        let pair = vars[i].split('=');
        if (pair[0] == variable) {
            return pair[1];
        }
    }
}

export
{
    getQueryVariable,
    getAxiosQueryVariable,
}